import { useEffect } from 'react';

import { useNavigate } from 'react-router';

import { useAppDispatch, useAppSelector } from 'dux/app/hooks';

import ErrorContainer from 'Containers/ErrorContainer';

import { type ConsultationCategoryProp } from 'PropTypes/consultationProps';

import ConsultationLoading from '../Scenes/ConsultationLoading';
import Scoring from '../Scenes/Scoring';

import * as trackingActions from 'dux/tracking/actions';
import { getUserFirstName } from 'dux/user/selectors';
import { useGetPrescriptionQuery } from 'dux/prescription/apiSlice';

type Props = {
  consultationCategory: ConsultationCategoryProp;
};

const ScoringPrescriptionContainer = ({ consultationCategory }: Props) => {
  const dispatch = useAppDispatch();

  const {
    data,
    isLoading,
    isSuccess,
    error,
    refetch: refetchPrescription,
  } = useGetPrescriptionQuery();

  const userName = useAppSelector(getUserFirstName);

  useEffect(() => {
    if (isSuccess) {
      dispatch(
        trackingActions.trackGtmEvent('survey', { survey_hair_damage_score: data.scoring.damaged }),
      );
    }
  }, [isSuccess, data, trackingActions.trackGtmEvent]);

  const navigate = useNavigate();
  const url = '/consultation/haircare/results/ingredients';

  if (isLoading) {
    return <ConsultationLoading noSurroundingStyle />;
  }

  if (error || !data) {
    return (
      <ErrorContainer
        error={error}
        retry={refetchPrescription}
        sentryMessage="Invalid state on ScoringPrescriptionContainer"
      />
    );
  }

  return (
    <Scoring
      consultationCategory={consultationCategory}
      onScoringSelectChange={() => dispatch(trackingActions.trackGoalSelectorPrescriptionChanged())}
      scoring={data.scoring}
      submit={() => navigate(url)}
      userName={userName}
    />
  );
};

export default ScoringPrescriptionContainer;
